import { type FC } from 'react'
import { CurrencyDollarIcon, KeyIcon, ChartPieIcon, DocumentTextIcon } from '@heroicons/react/24/outline'
import { useTranslation } from '@egw/i18n'
import { WelcomeStepV2 } from '../welcome-step-v2/welcome-step-v2'

// When both Persons have accepted disclosures
export const WelcomeStepsJointV2: FC<{ jointPersonFirstName: string }> = ({ jointPersonFirstName = '' }) => {
  const { t } = useTranslation('features-enrollment')

  return (
    <>
      <WelcomeStepV2
        icon={<DocumentTextIcon className="size-6" />}
        testId="fund-checking"
        title={t('joint.welcome.steps_v2.step_1.title', { name: jointPersonFirstName })}
        description={t('joint.welcome.steps_v2.step_1.description_yeet_coastal', { name: jointPersonFirstName })}
      />
      <WelcomeStepV2
        icon={<KeyIcon className="size-6" />}
        testId="earn-with-savings"
        title={t('joint.welcome.steps_v2.step_2.title')}
        description={t('joint.welcome.steps_v2.step_2.description_yeet_coastal')}
      />
      <WelcomeStepV2
        icon={<CurrencyDollarIcon className="size-6" />}
        testId="fund-joint-accounts"
        title={t('joint.welcome.steps_v2.step_3.title_yeet_coastal')}
        description={t('joint.welcome.steps_v2.step_3.description_yeet_coastal')}
      />
      <WelcomeStepV2
        icon={<ChartPieIcon className="size-6" />}
        testId="configure-portfolio"
        title={t('joint.welcome.steps_v2.step_4.title')}
        description={t('joint.welcome.steps_v2.step_4.description')}
      />
    </>
  )
}
